import React from 'react'
import { Link } from "react-router-dom";
import HowDoes from '../home/HowDoes';
import HomeGallery from '../home/HomeGallery';


const AboutUs = () => {
  return (
    <>

      <section className="page-hero bg_cover p-r z-1" style={{ backgroundImage: 'url("assets/img/TDR.jpg")' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              {/*=== Page Content ===*/}
              <div className="page-content text-center">
                <h1>About Us</h1>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li>AboutUs</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="renvia-about_three pt-115 pb-120" style={{ marginTop: "-90px" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              {/* Renvia Content Box */}
              <div className="renvia-content-box mb-5 mb-xl-0">
                <div className="section-title mb-45">
                  <span className="sub-title aos-init" data-aos-duration={1000}>Who We Are<img src="assets/images/line2.png" alt="line" /></span>
                  <h2 className="text-anm" aria-label="We created historic real estate ventures.">
                    We created historic real estate ventures.
                  </h2>
                </div>
                <div className="features-box-wrap">
                  <div className="renvia-image aos-init" data-aos-duration={1000}>
                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/about/about-img1.jpg" alt="about image" />
                  </div>
                  <div className="features- list">
                    <div className="renvia-iconic-left-box style-two mb-25 aos-init" data-aos-duration={1000}>
                      <div className="content">
                        <h6 className="title"><span className="icon"><img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/about/icon1.png" alt="icon" /></span><b>Affordable Price</b></h6>
                        <p style={{ textAlign: "justify" }}>At Earth Bond Property, we understand the importance of cost-effectiveness in real estate transactions. </p>
                      </div>
                    </div>
                    <div className="renvia-iconic-left-box style-two aos-init" data-aos-duration={1200}>
                      <div className="content">
                        <h6 className="title"><span className="icon"><img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/about/icon2.png" alt="icon" /></span><b>Outstanding Property</b></h6>
                        <p style={{ textAlign: "justify" }}>Earth Bond Property stands out for its remarkable portfolio of properties.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="renvia-button-wrap mt-40 aos-init" data-aos-duration={1000}>
                  <div className="renvia-support-box">
                    <div className="thumb">
                      <img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/about/support.jpg" alt="support" />
                    </div>
                    <div className="content">
                      <h5 className="title">Call Us For Any Inquiry</h5>
                      <h6><a href="tel:+91 8823000048">+91 8823000048</a></h6>
                    </div>
                  </div>
                  {/* <div className="renvia-button">
                    <a href="about.html" className="theme-btn style-one">Learn More<i className="far fa-arrow-right" /></a>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-8">
              {/* Renvia Text Box */}
              <div className="renvia-text-box aos-init" data-aos-duration={1000}>
                <p style={{ textAlign: "justify" }}>At Earth Bond Property, we bring trust, expertise, and dedication to every square foot. With a passion for property and a commitment to integrity, we’re here to guide you through seamless real estate experiences — whether you're investing, leasing, or building your future. Let us be the key to your next great opportunity. Your Trusted Real Estate Partner.</p>
                <p style={{ textAlign: "justify" }}>Earth Bond Property company, also known as a real estate agency or realty firm, is a business that specializes in buying, selling, renting, managing, and investing in real property, which includes land, residential homes, commercial buildings, and other real estate assets.</p>
                <div className="renvia-image mt-55">
                  <img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/about/about-img2.jpg" alt="about image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="renvia-counter-sec bg_cover pt-70 pb-30" style={{ backgroundImage: 'url("https://nayonacademy.com/html/renvia-html/assets/images/innerpage/bg/counter-bg.png")', marginTop: "-90px" }}>
        <div className="container">
          <div className="counter-wrapper text-white">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1000}>
                  <div className="content">
                    <h2><span className="counter">100+</span><span className="symbol"> </span></h2>
                    <p>Project Available</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                {/* Renvia Counter Item */}
                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1200}>
                  <div className="content">
                    <h2><span className="counter">2000+</span><span className="symbol"></span></h2>
                    <p>Project Sold</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                {/* Renvia Counter Item */}
                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1400}>
                  <div className="content">
                    <h2><span className="counter">500+</span> <span className="symbol"></span></h2>
                    <p>New Home</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12 item-border">
                {/* Renvia Counter Item */}
                <div className="renvia-counter-item style-one text-center mb-40 aos-init aos-animate" data-aos-duration={1600}>
                  <div className="content">
                    <h2><span className="counter">100%</span> <span className="symbol"> </span></h2>
                    <p>Customer Satisfaction</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="renvia-about_two pt-120 pb-120" style={{ marginTop: "-60px" }}>
        <div className="shape shape-one"><img src="https://nayonacademy.com/html/renvia-html/assets/images/home-two/about/shape1.png" alt="shape" /></div>
        {/* <div className="shape shape-two"><img src="https://nayonacademy.com/html/renvia-html/assets/images/home-two/about/shape2.png" alt="shape" /></div> */}
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-10">
              <div className="renvia-image-box mb-5 mb-xl-0 aos-init aos-animate" data-aos-duration={1000}>
                <div className="renvia-image">
                  <img src="https://nayonacademy.com/html/renvia-html/assets/images/home-two/about/about-img1.jpg" alt="about image" />
                </div>
                <div className="renvia-content-box">
                  <div className="content text-center text-white">
                    <h2>100%</h2>
                    <p>Client Retention Rate</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-10">
              <div className="renvia-content-box">
                <div className="section-title">
                  <span className="sub-title aos-init aos-animate" data-aos-duration={1000}>About Us<img src="assets/images/line2.png" alt="line" /></span>
                  <h2 className="text-anm" aria-label="Explore Our Luxurious Home with All the Amenities">
                    Why Choose Us?
                  </h2>
                </div>
                <p data-aos-duration={1000} className="aos-init aos-animate" style={{ textAlign: "justify" }}>
                  At Earth Bond Property, we help you find the right property with complete transparency and professional guidance. All our plots and properties are properly verified so that you can invest safely and confidently. We offer plots in prime and developing locations with great future value. Our team focuses on understanding your needs and providing the best property options. We provide budget-friendly plots and properties suitable for every investor. From property selection to documentation and registration, we assist you at every step.
                </p>
                <div className="renvia-tabs aos-init" data-aos-duration={1000}>
                  <ul className="nav nav-tabs" role="tablist">
                    <li>
                      <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#mission" aria-selected="true" role="tab">Our Mission</button>
                    </li>
                    <li>
                      <button className="nav-link" data-bs-toggle="tab" data-bs-target="#vision" aria-selected="false" tabIndex={-1} role="tab">Our Vision</button>
                    </li>

                  </ul>
                </div>
                <div className="tab-content aos-init" data-aos-duration={1200}>
                  <div className="tab-pane fade show active" id="mission" role="tabpanel">
                    <div className="content-box">
                      <div className="renvia-image">
                        <img src="assets/img/mission.webp" alt="about" />
                      </div>
                      <div className="content">
                        <p style={{ textAlign: "justify" }}>Our mission at Earth Bond Property is to make property buying simple, transparent, and trustworthy.
                          We aim to provide verified plots and real estate opportunities that help customers build secure futures and smart investments.</p>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="vision" role="tabpanel">
                    <div className="content-box">
                      <div className="renvia-image">
                        <img src="assets/img/vision.webp" alt="about" />
                      </div>
                      <div className="content">
                        <p style={{ textAlign: "justify" }}>Our vision is to become a trusted and leading real estate company by delivering reliable property solutions, creating long-term customer relationships, and contributing to the development of modern and well-planned communities.</p>
                      </div>
                    </div>
                  </div>

                </div>
                {/* <div className="renvia-button-wrap aos-init" data-aos-duration={1000}>
                  <div className="renvia-button">
                    <a href="about.html" className="theme-btn style-one">Know More <i className="far fa-arrow-right" /></a>
                  </div>
                  <div className="call-support-box">
                    <div className="icon">
                      <i className="far fa-phone-alt" />
                    </div>
                    <div className="content">
                      <span className="title">Call Us For Any Inquiry</span>
                      <br />
                      <a href="tel:+91 8823000048">
                        <h6><b>+91 8823000048</b></h6>
                      </a>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="renvia-work-sec pt-120 " style={{ marginTop: "-200px" }}>
        <div className="container">
          {/* Work Wrapper */}
          <div className="work-wrapper">
            {/* Renvia Work Item */}
            <div className="renvia-work-item mb-60 aos-init" data-aos-duration={1000}>
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  {/* Content */}
                  <div className="content mb-5 mb-xl-0">
                    <span className="sub-text"> Our Trusted Real Estate</span>
                    <div className="step">01</div>
                    <h3 className="title">Excellence</h3>
                    <p>We focus on delivering the highest standards in every property we deal with. From property verification to customer support, our team ensures excellence in service so that every client receives reliable and professional assistance.</p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-8">
                  {/* Thumbnail */}
                  <div className="thumbnail">
                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/gallery/work-img1.jpg" alt="work image" />
                  </div>
                </div>
              </div>
            </div>
            {/* Renvia Work Item */}
            <div className="renvia-work-item mb-60 aos-init" data-aos-duration={1200}>
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  {/* Content */}
                  <div className="content mb-5 mb-xl-0">
                    <span className="sub-text">Our Trusted Real Estate</span>
                    <div className="step">02</div>
                    <h3 className="title">Quality</h3>
                    <p>We believe that quality matters the most in real estate. That’s why we carefully select and verify every property before presenting it to our clients, ensuring safe, secure, and valuable investments.</p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-8">
                  {/* Thumbnail */}
                  <div className="thumbnail">
                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/gallery/work-img2.jpg" alt="work image" />
                  </div>
                </div>
              </div>
            </div>
            {/* Renvia Work Item */}
            <div className="renvia-work-item mb-60 aos-init" data-aos-duration={1400}>
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  {/* Content */}
                  <div className="content mb-5 mb-xl-0">
                    <span className="sub-text">Achievement</span>
                    <div className="step">03</div>
                    <h3 className="title">Buy or rent homes</h3>
                    <p>Over the years, we have successfully helped many clients find their ideal homes and investment properties. Our achievements reflect the trust our customers place in us and our commitment to delivering the best results.</p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-8">
                  {/* Thumbnail */}
                  <div className="thumbnail">
                    <img src="https://nayonacademy.com/html/renvia-html/assets/images/innerpage/gallery/work-img3.jpg" alt="work image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div style={{marginTop:"100px"}}>
        <HowDoes />
        <HomeGallery />
      </div>
    </>
  )
}

export default AboutUs